import { render, staticRenderFns } from "./PaymentsAdd.vue?vue&type=template&id=71044838&scoped=true&"
import script from "./PaymentsAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71044838",
  null
  
)

export default component.exports